import { render } from "./etmfpiechart.vue?vue&type=template&id=f5c99cb4&scoped=true"
import script from "./etmfpiechart.vue?vue&type=script&lang=js"
export * from "./etmfpiechart.vue?vue&type=script&lang=js"

import "./etmfpiechart.vue?vue&type=style&index=0&id=f5c99cb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c99cb4"]])

export default __exports__